import {Component, OnInit} from '@angular/core';
import {MenuButtonsPageComponent} from '../../shared/components/menu-buttons-page/menu-buttons-page.component';
import {Router} from '@angular/router';
import {LangService} from '../../core/services/lang.service';
import {HowWorksService} from '../../core/api/how-works.service';
import {getHowWorks, HowWork, HowWorks} from '../../shared/models/how-works.model';

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  imports: [MenuButtonsPageComponent],
})

export class HowItWorksComponent implements OnInit {

  backgroundImage = '/images/how-it-works.png';

  topActions: TopAction[] = [];

  constructor(private router: Router, private howWorksService: HowWorksService, private langService: LangService) {
  }

  ngOnInit(): void {
    this.loadHowWorks();
  }

  private loadHowWorks() {
    this.howWorksService.getHowWorks().subscribe({
      next: (howWorks: HowWorks
      ) => {
        const rulesByLang = getHowWorks(howWorks);
        this.topActions = rulesByLang.map((rule: HowWork) => ({
          id: rule.title,
          label: rule.title,
          href: `/how-it-works/${rule.id}`,
        }));

      },
      error: (error) => {
        console.error('Error al obtener como funciona:', error);
      }
    });
  }

  onActionClick(action: TopAction) {
    if (action.href) {
      const ruleId = action.href.split('/').pop();
      if (ruleId) {
        this.router.navigate(['/how-it-works', ruleId]);
      }
    }
  }
}
